import { render, staticRenderFns } from "./FormPixel.vue?vue&type=template&id=76343c96&"
import script from "./FormPixel.vue?vue&type=script&lang=js&"
export * from "./FormPixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports